import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'hooks/apollo';
import { Tooltip } from '@mui/material';
import { EXPORT_COMPETENCE_ORDERS } from '../../../mutations';
import { COMPETENCE_ORDER_FILTERS_QUERY } from '../../../queries';
import { buildExportDownloadUrl } from 'features/downloadList/api';
import { CloudDownload } from '@mui/icons-material';
import { fileType } from 'constants/fileTypes';
import { useSimpleError } from 'hooks/apolloWrappers';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { convertBase64ToFile } from 'utils/base64FileConversion';
import saveAs from 'file-saver';
import { IconButton } from '@totalsoft/rocket-ui';
import { getOidcConfigName } from 'utils/functions';
import { useOidcAccessToken } from '@axa-fr/react-oidc';

const ExportAction = () => {
  const [t] = useTranslation();
  const showError = useSimpleError();
  const [filters, setFilters] = useState({});
  const { accessToken } = useOidcAccessToken(getOidcConfigName());

  const [exportAnchorEl, setShowHandleClose] = useState(null);
  const isExportOpen = Boolean(exportAnchorEl);

  const [exportCompetenceOrders] = useMutation(EXPORT_COMPETENCE_ORDERS, {
    onCompleted: async ({ exportCompetenceOrders }) => {
      let downloadLink = null;
      try {
        if (exportCompetenceOrders.fileBytes) {
          saveAs(convertBase64ToFile(exportCompetenceOrders.fileBytes), exportCompetenceOrders.fileName);
          return;
        }
        downloadLink = await buildExportDownloadUrl(exportCompetenceOrders.filePath, exportCompetenceOrders.fileName, accessToken);
      } catch (error) {
        showError(error);
      }
      if (downloadLink) {
        window.location.href = downloadLink;
      }
    }
  });

  useQuery(COMPETENCE_ORDER_FILTERS_QUERY, {
    onCompleted: data => {
      if (data)
        setFilters({
          approvalTypeName: data.competenceOrderListFilters.approvalTypeName.value,
          statusName: data.competenceOrderListFilters.statusName.value,
          fullTextFilter: data.competenceOrderListFilters.fullTextFilter.value
        });
    }
  });

  const onExport = filters => {
    exportCompetenceOrders({ variables: { input: filters } });
  };

  const handleExportClose = () => {
    setShowHandleClose(null);
  };

  const handleExportClick = event => {
    setShowHandleClose(event.currentTarget);
  };

  const handleExport = (fileType, filters) => () => {
    onExport({ ...filters, fileType });
    setShowHandleClose(null);
  };

  return (
    <>
      <Tooltip placement='top' title={t('Tooltips.DownloadCompetenceOrderList')}>
        <div>
          <IconButton color='primary' onClick={handleExportClick}>
            <CloudDownload />
          </IconButton>
          <Menu id='render-export-menu' anchorEl={exportAnchorEl} open={isExportOpen} onClose={handleExportClose}>
            <MenuItem onClick={handleExport(fileType.excel, filters)}>{t('Export.Excel')}</MenuItem>
            <MenuItem onClick={handleExport(fileType.csv, filters)}>{t('Export.CSV')}</MenuItem>
          </Menu>
        </div>
      </Tooltip>
    </>
  );
};

export default ExportAction;
